// extracted by mini-css-extract-plugin
module.exports = {"controlsWrapper":"carousel_controlsWrapper__4qCBl","pagination":"carousel_pagination__oAAFx","customPagination":"carousel_customPagination__TSfQw"};